export default {
  props: {
    uuid: {
      Type: String,
      required: true,
    },
  },
  components: {
    FileUploadSlot: () => import('@/components/common/form/FileUploadSlot.vue'),
  },
  data() {
    return {
      loading: false,
      mimeTypes: [
        'image/gif',
        'image/png',
        'image/jpeg',
        'image/bmp',
        'image/webp',
        'application/pdf',
      ],
    }
  },
  async created() {},
  methods: {
    async uploadFile(file) {
      if (this.loading) {
        return
      }

      try {
        this.loading = true

        if (this.mimeTypes.indexOf(file.type) < 0) {
          await this.$swal.basic.error('서류는 jpg, png, pdf 파일만 업로드하실 수 있습니다.')
          return
        }

        if (file.size > 1024 * 1024 * 10) {
          await this.$swal.basic.error('파일의 크기는 10MB까지 업로드하실 수 있습니다.')
          return
        }

        const { data } = await this.$defaultApi.postCreditPaysRequestFile(this.uuid, file)
        await this.$swal.basic.alert('서류 제출이 완료되었습니다.')
        this.$emit('upload', data)
      } finally {
        this.loading = false
      }
    },
  },
}
